import * as React from "react";
function SvgTriangleBarRight(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M5 0l16 16L5 32V0z" />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={4}
        d="M25 0v32"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTriangleBarRight);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
